import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "flex flex-column w-full" }
const _hoisted_2 = { class: "flex mb-3 px-3" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "flex flex-wrap gap-3 px-2" }
const _hoisted_5 = { class: "flex align-items-center gap-3 flex-1" }
const _hoisted_6 = { class: "field p-3 w-full bg-gray-50 border-1 border-primary-300 border-round-md" }
const _hoisted_7 = { class: "field mt-5 w-full" }
const _hoisted_8 = { class: "field mt-5 w-full" }
const _hoisted_9 = { class: "flex mt-6" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = {
  class: "flex flex-grow-1 p-2 pt-0 w-full",
  style: {"height":"100vh"}
}
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = {
  key: 0,
  class: "w-3 xl:w-4 ml-2 mr-2"
}
const _hoisted_15 = { class: "flex align-items-center" }

import { onMounted, ref, toRefs, watch, computed } from 'vue';
import Chip from 'primevue/chip';
import Dialog from 'primevue/dialog';
import Fieldset from 'primevue/fieldset';
import { FilterMatchMode } from 'primevue/api';
import { useDateTime } from '@/composables';
import { EMIT } from '@/enum';
import { IntegrationSchoolDayService } from '@/services';
import { useStudentReferralStore } from '@/store';
import { OrganizationInterface } from '@/types';

interface PropsInterface {
  open: boolean;
  organization: OrganizationInterface;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'UserReferralSISModal',
  props: {
    open: { type: Boolean },
    organization: {}
  },
  emits: [EMIT.CANCEL, EMIT.UPDATE],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { open, organization } = toRefs(props);

const referralType = ref(null);

const referralsSelected = ref<number[]>([]);

const referralStore = useStudentReferralStore();

const students = ref([]);

watch(organization, () => init());

onMounted(async () => init());

const canImport = computed(() => !(Boolean(referralType.value) && Boolean(referralsSelected.value.length)));

const hasFiltersSet = computed(() => {
  return Object.keys(filters.value).some((key) => {
    const filter = filters.value[key];
    return filter.value !== null && filter.value !== '' && filter.value !== undefined;
  });
});

const init = async () => {
  const schoolId = organization.value.integration_organization.sis_id;
  const response = await IntegrationSchoolDayService.organizationStudents(null, schoolId, 'student_last_name', 'desc');
  students.value = response.data.data;
};

const onCancel = () => {
  referralsSelected.value = [];
  referralType.value = null;
  filters.value.global.value = null;
  filters.value['student_grade.grade'].value = null;
  emit(EMIT.CANCEL);
};

const onImport = () => {
  referralStore.onSISImport(referralType.value, referralsSelected.value);
  onCancel();
  emit(EMIT.UPDATE);
};

const onFilterClear = () => {
  filters.value.global.value = null;
  filters.value['student_grade.grade'].value = null;
};

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  'student_grade.grade': { value: null, matchMode: FilterMatchMode.EQUALS },
});

const loading = ref(false);

const onSort = async (event) => {
  loading.value = true;
  const orderBy = event.sortField;
  const order = event.sortOrder === 1 ? 'asc' : 'desc';
  const schoolId = organization.value.integration_organization.sis_id;
  const response = await IntegrationSchoolDayService.organizationStudents(null, schoolId, orderBy, order);
  students.value = response.data.data;
  loading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(open),
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_isRef(open) ? (open).value = $event : null)),
    modal: "",
    style: { width: '75vw' },
    class: "dialog__container",
    closable: false,
    "close-on-escape": false,
    "block-scroll": true,
    draggable: false,
    onHide: onCancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mr-1" }, "SIS Student Import /", -1)),
          _createElementVNode("span", {
            class: "text-primary",
            textContent: _toDisplayString(_unref(organization).name)
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "referral_type",
                class: "required"
              }, "Referral Type", -1)),
              _createVNode(_component_Dropdown, {
                modelValue: referralType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((referralType).value = $event)),
                type: "secondary",
                options: _unref(referralStore).referralTypes,
                "option-label": "title",
                "option-value": "id",
                q: "",
                placeholder: "Select Referral Type",
                class: "w-full"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_IconField, { "icon-position": "left" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputIcon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        name: "search",
                        class: "text-lg"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_InputText, {
                    modelValue: filters.value.global.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.global.value) = $event)),
                    class: "w-full",
                    placeholder: "Search by Student Name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Dropdown, {
                modelValue: filters.value['student_grade.grade'].value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value['student_grade.grade'].value) = $event)),
                type: "secondary",
                options: _unref(referralStore).gradeOptions,
                "show-clear": "",
                placeholder: "Filter By Grade",
                class: "w-full"
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (hasFiltersSet.value)
              ? (_openBlock(), _createBlock(_component_AppButton, {
                  key: 0,
                  class: "mr-3",
                  type: "secondary",
                  text: "Clear Filters",
                  onClick: onFilterClear
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_AppButton, {
              class: "mr-3",
              type: "secondary",
              text: "Cancel",
              onClick: onCancel
            }),
            _createVNode(_component_AppButton, {
              type: "primary",
              text: "Import",
              disabled: canImport.value,
              onClick: onImport
            }, null, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DataTable, {
            selection: referralsSelected.value,
            "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((referralsSelected).value = $event)),
            filters: filters.value,
            "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((filters).value = $event)),
            value: students.value,
            loading: loading.value,
            "loading-icon": "logo-spinner",
            class: "table-contents border-1 border-gray-100 border-round-md w-full",
            "data-key": "student_id",
            scrollable: "",
            "scroll-height": "flex",
            onSort: onSort
          }, {
            empty: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("There are no students available", -1)
            ]))]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                "selection-mode": "multiple",
                "header-style": "max-width: 50px;",
                "body-style": "max-width: 50px;"
              }),
              _createVNode(_component_Column, {
                header: "SSID",
                field: "student_id",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                header: "Student First Name",
                field: "student_first_name",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                header: "Student Last Name",
                field: "student_last_name",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                header: "Gender",
                field: "student_gender",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                header: "Birth Date",
                field: "student_birthdate",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.student_birthdate))
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Grade",
                "filter-field": "student_grade.grade",
                "sort-field": "student_grade",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(data.student_grade.grade)
                  }, null, 8, _hoisted_13)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Parent First Name",
                field: "parent_first_name",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                header: "Parent Last Name",
                field: "parent_last_name",
                sortable: ""
              })
            ]),
            _: 1
          }, 8, ["selection", "filters", "value", "loading"])
        ]),
        (referralsSelected.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_unref(Fieldset), null, {
                legend: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-bold" }, "Students Selected", -1)),
                    _createVNode(_component_Tag, {
                      value: referralsSelected.value.length,
                      rounded: "",
                      class: "ml-2 border-circle w-1rem h-1rem text-xs text-white"
                    }, null, 8, ["value"])
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referralsSelected.value, (item, key) => {
                    return (_openBlock(), _createBlock(_unref(Chip), {
                      key: key,
                      class: "m-1",
                      label: `${item.student_first_name} ${item.student_last_name}`
                    }, null, 8, ["label"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})